var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('spinner',{attrs:{"size":_vm.size,"line-size":_vm.lineSize,"line-bg-color":_vm.colors.primary,"line-fg-color":_vm.colors.white,"spacing":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }